import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectLanguagesForSelector } from '../../state/patient.selectors';
import * as PatientActions from '../../state/patient.actions';
import { ModalService } from 'Shared/app/core/helpers/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { SELECTION_KEYS } from 'Shared/app/constants/keyDown.constants';
import * as LanguageFunctions from 'Shared/app/core/helpers/language.helper';
import { TextDirection } from 'Shared/app/constants/languages.constants';

@Component({
  selector: 'wfp-language-picker',
  templateUrl: './language-picker.component.html',
  standalone: false
})
export class LanguagePickerComponent {
  readonly #store = inject(Store);
  readonly #modalService = inject(ModalService);
  readonly #translate = inject(TranslateService);

  protected languageData$ = this.#store.select(selectLanguagesForSelector);

  changeLanguageKey(
    event: KeyboardEvent,
    languageCode: number,
    hasSession: boolean,
    activeFormName: string,
    activeFormLanguages: number[],
    currentLanguageCode: number
  ) {
    if (SELECTION_KEYS.includes(event.code)) {
      this.changeLanguage(languageCode, hasSession, activeFormName, activeFormLanguages, currentLanguageCode);
    }
  }

  changeLanguage(
    languageCode: number,
    hasSession: boolean,
    activeFormName: string,
    activeFormLanguages: number[],
    currentLanguageCode: number
  ) {
    if (languageCode === currentLanguageCode) {
      return;
    }
    if (!activeFormName) {
      this.#store.dispatch(PatientActions.setCurrentLanguage({ language: languageCode, hasSession: hasSession }));
      return;
    }
    const keys = [
      'patient.templates.modals.changeLanguage',
      'patient.templates.bookingOverview.languageDoesNotExistIsMapped',
      'patient.templates.modals.Ok',
      'patient.templates.modals.cancel'
    ];
    this.#translate.get(keys).subscribe((translations) => {
      const message = activeFormLanguages.includes(languageCode)
        ? ' '
        : `${activeFormName} ${translations['patient.templates.bookingOverview.languageDoesNotExistIsMapped']}`;
      this.#modalService
        .newConfirm(
          translations['patient.templates.modals.changeLanguage'],
          message,
          '',
          translations['patient.templates.modals.Ok'],
          translations['patient.templates.modals.cancel'],
          undefined,
          undefined,
          LanguageFunctions.getLanguageObject(currentLanguageCode)?.rtl ? TextDirection.RTL : TextDirection.LTR
        )
        .pipe(take(1))
        .subscribe((res) => {
          if (res) {
            setTimeout(() => {
              this.#store.dispatch(
                PatientActions.setCurrentLanguage({ language: languageCode, hasSession: hasSession })
              );
            }, 500);
          }
        });
    });
  }
}
